export const QueryKeys = {
	contribution_history: ['contribution_history'],
	user_info: ['user_info'],
	payment_contract: ['payment_contract'],
	management_contract: ['management_contract'],
}
